/* eslint-disable indent */
import React, { FC } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import { EFoodPrice, Matrix } from "types/Product";
import { formatCurrency } from "tools/stringUtils";
import { tss } from "tss-react/mui";
import {
  DiscountEntry,
  HistoricalOrderMatrix,
  HistoricalOrderPrice,
} from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import { StyledProtectable } from "../StyledProtectable";

const useStyles = tss.create(() => ({
  description: {
    whiteSpace: "nowrap",
  },
}));

const isMatrix = (item: Matrix | HistoricalOrderMatrix): item is Matrix =>
  "handlingCode" in item;

interface StyledPriceTableSmallProps {
  matrix: Matrix[] | HistoricalOrderMatrix[];
  prices?: EFoodPrice[] | HistoricalOrderPrice[];
  shortDesc?: boolean;
  discountPrices?: DiscountEntry[];
  quantityLayout?: boolean;
}

const StyledPriceTableSmall: FC<StyledPriceTableSmallProps> = ({
  matrix,
  prices,
  discountPrices,
  shortDesc = false,
  quantityLayout = false,
}) => {
  const { classes } = useStyles();

  const matrixEntry =
    matrix.length === 1 && !isMatrix(matrix[0])
      ? matrix[0]
      : (matrix as Matrix[]).find(
          (item) => isMatrix(item) && item.handlingCode === "1"
        );

  const priceEntry = prices?.find(
    (item) => item.matrixShortDescription === matrixEntry?.shortDesc
  );

  const discountPrice = discountPrices?.[0] ?? undefined;

  const descriptionText = shortDesc
    ? matrixEntry?.shortDesc
    : matrixEntry?.longDesc;

  const priceInfo = (
    <StyledProtectable permission="show.price">
      <Typography variant="body2" align="right">
        {discountPrice ? (
          <>
            <s>{formatCurrency(priceEntry?.price)}</s>
            <br />
            <b>{formatCurrency(discountPrice.discountPrice)}</b>
          </>
        ) : (
          <b>{formatCurrency(priceEntry?.price)}</b>
        )}
      </Typography>
    </StyledProtectable>
  );

  if (quantityLayout) {
    return (
      <Grid container pb={1}>
        <Grid xs={6}>
          <Typography
            variant="body2"
            align="left"
            className={classes.description}>
            {descriptionText}
          </Typography>
        </Grid>
        <Grid xs={6}>{priceInfo}</Grid>
      </Grid>
    );
  }

  return (
    <>
      <Typography variant="body2" align="right" pr={1}>
        {descriptionText}
      </Typography>
      {priceInfo}
    </>
  );
};

export default StyledPriceTableSmall;
